import { LocationDescriptor } from "history";

export function toPath(to: LocationDescriptor) {
    if (typeof to !== "string") {
        return to.pathname;
    }

    return to;
}
